module.exports = __webpack_public_path__ + "static/media/vei.11c8fc08.m4a";